import * as openpgp from "openpgp";
import { ISingleBinaryKeys } from "./generateSingleBinaryFromMultiplePublicKeys";
import { readAsBase64 } from "./readAsBase64";

export const generateKey = async (
  email: string,
): Promise<ISingleBinaryKeys> => {
  const options: openpgp.KeyOptions = {
    userIds: [
      {
        name: "",
      },
    ],
    curve: "secp256k1",
    numBits: 2048,
  };

  const key = await openpgp.generateKey(options);
  const pubDecoded = await openpgp.key.readArmored(key.publicKeyArmored);
  const privDecoded = await openpgp.key.readArmored(key.privateKeyArmored);
  const publicKeyResultString = new Uint8Array(
    pubDecoded.keys[0].toPacketlist().write(),
  );
  const privateKeyResultString = new Uint8Array(
    privDecoded.keys[0].toPacketlist().write(),
  );

  return {
    PublicKey: await readAsBase64(publicKeyResultString),
    PrivateKey: await readAsBase64(privateKeyResultString),
    cleanPublicKey: pubDecoded,
    cleanPrivateKey: privDecoded,
  };
};
